import React, { useEffect, useRef, useState } from 'react';
import { Table, Button, Input, Card } from 'antd';
import { ColumnProps, ColumnType } from 'antd/lib/table';
import Highlighter from 'react-highlight-words';
import { CaretRightOutlined, SearchOutlined, FilterOutlined, EditOutlined, SplitCellsOutlined, CheckCircleTwoTone, CloseOutlined, RotateRightOutlined, RedoOutlined, DoubleLeftOutlined, PrinterOutlined } from '@ant-design/icons'
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { GrnService } from '@gtpl/shared-services/procurement';
import { GrnItemIdRequest } from '@gtpl/shared-models/procurement-management';
import GrnInspectionGrid from './grn-inspection-grid';

// const { Column } = Table;

// export interface GrnInspectionProps{
//   grnItemId:number
// }

const GrnInspectionView = () => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [page,setPage] = useState<number>(1)

  const gnrservice = new GrnService();
  const [inspectionviewData, setinspectionviewData] = useState<any[]>([])
  const [expandedIndex, setExpandedIndex] = useState([]);
  const [pageSize, setPageSize] = useState<number>(1);


  useEffect(() => {
    getInspectionColumnData();
    
  }, []);

 
  const getInspectionColumnData = () => {
    gnrservice.getInspectionDetails().then(res => {
      // console.log(res, 'ppppppppppppp');

      if (res.status) {
        setinspectionviewData(res.data);

      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    })
  }


  const setIndex = (expanded, record) => {
    // console.log(expanded,"--------------------")
    // console.log(record,"\\\\\\\\\\\\\\\\\\\\\\\\\\")
    const expandedRows = []
    if (expanded) {
      // console.log(expanded,"ttttttttttttttttt\\\\")
      expandedRows.push(record.grnItemId);
      setExpandedIndex(expandedRows);
    } else {
      // console.log(expanded,"88888888888888888\\\\")

      setExpandedIndex(expandedRows);
    }
    // console.log(expandedRows,"555555555555555555555555555555");
    
  }

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),



    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      console.log(searchInput.current);
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },



    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const handleExpand = (expanded, record) => {
    const keys = expanded ? [record.key] : [];
    setExpandedRowKeys(keys);
  };

  const inspectionViewColumns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: 'Vendor',
      dataIndex: 'vendor',
      width: 130,
      align: 'left',
      ...getColumnSearchProps('vendor'),
      sorter: (a, b) => a.vendor.localeCompare(b.vendor),
      sortDirections: ['descend', 'ascend'],

    },
    {
      title: 'Invoice Number',
      dataIndex: 'invNo',
      width: 130,
      align: 'left',
      ...getColumnSearchProps('invNo'),
      sorter: (a, b) => a.invNo.localeCompare(b.invNo),
      sortDirections: ['descend', 'ascend'],

    },
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      width: 130,
      align: 'left',
      ...getColumnSearchProps('itemName'),
      sorter: (a, b) => a.itemName.localeCompare(b.itemName),
      sortDirections: ['descend', 'ascend'],

    },
    {
      title: 'Grn Quantity',
      dataIndex: 'grnQuantity',
      width: 130,
      align: 'left',
      ...getColumnSearchProps('grnQuantity'),
      sorter: (a, b) => a.grnQuantity.localeCompare(b.grnQuantity),
      sortDirections: ['descend', 'ascend'],

    },
    {
      title: 'Inspection Quantity',
      dataIndex: 'inspectionQuantity',
      width: 130,
      align: 'left',
      ...getColumnSearchProps('inspectionQuantity'),
      sorter: (a, b) => a.inspectionQuantity-b.inspectionQuantity,
      sortDirections: ['descend', 'ascend'],
    }
  ]

  // const inspectionView1Columns: ColumnProps<any>[] = [
  //   {
  //     title: 'STATUS',
  //     dataIndex: 'status',
  //     width: 130,
  //     align: 'left',
  //     ...getColumnSearchProps('status'),
  //     sorter: (a, b) => a.status.localeCompare(b.status),
  //     sortDirections: ['descend', 'ascend'],
  //   },
  //   {
  //     title: 'QUANTITY',
  //     dataIndex: 'quantity',
  //     width: 130,
  //     align: 'left',
  //     ...getColumnSearchProps('quantity'),
  //     sorter: (a, b) => a.quantity.localeCompare(b.quantity),
  //     sortDirections: ['descend', 'ascend'],
  //   },
  //   {
  //     title: ' REASON',
  //     dataIndex: 'reason',
  //     width: 130,
  //     align: 'left',
  //     ...getColumnSearchProps('reason'),
  //     sorter: (a, b) => a.reason.localeCompare(b.reason),
  //     sortDirections: ['descend', 'ascend'],
  //   },
  //   {
  //     title: 'INSPECTION DATE',
  //     dataIndex: 'inspectionDate',
  //     width: 130,
  //     align: 'left',
  //     ...getColumnSearchProps('inspectionDate'),
  //     sorter: (a, b) => a.inspectionDate.localeCompare(b.inspectionDate),
  //     sortDirections: ['descend', 'ascend'],
  //   }
  // ]


  const renderItems = (record, index, indent, expanded) => {
  //  getInspectionReasonsData (record.grnItemId) 
 
      return (
        <GrnInspectionGrid grnItemId={record.grnItemId}/>
      )
  
  }



  return (
    <Card
      title='GRN INSPECTION VIEW' style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', fontSize: '15px' }}>
      <div>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>

        </div>
      </div>


      <Table
        rowKey={record => record.grnItemId}
        columns={inspectionViewColumns}
        dataSource={inspectionviewData}
        
        size='small'
        expandedRowRender={renderItems}
        expandedRowKeys={expandedIndex}
        onExpand={setIndex}
        expandIconColumnIndex={5}
        pagination={{
          onChange(current,pageSize) {
            setPage(current);
            setPageSize(pageSize);
          }
        }}
         />


    </Card>
  );
};


export default GrnInspectionView;
